<div class="header">
  <div class="header-title">
    Edit Camera: <span class="cameraName">{{ data.camera.name }}</span>
  </div>
  <button mat-icon-button mat-dialog-close="">
    <mat-icon class="fa-regular fa-x"></mat-icon>
  </button>
</div>

<div class="camera-form-dialog-content" mat-dialog-content>
  <div class="dialogContainer">
    <div class="video">
      <sn-audit-camera-stream-view
        [autoplay]="true"
        [camera]="camera"
        [controls]="true"
        [actions]="false"
        class="camera-stream-view"
      >
      </sn-audit-camera-stream-view>
      <button
        mat-button
        color="success"
        type="submit"
        (click)="submitStream()"
        class="seeChangesButton"
        *ngIf="currentTab === 'Stream'"
      >
        See Changes
      </button>
    </div>
    <mat-tab-group (selectedTabChange)="tabChanged($event)">
      <mat-tab label="General">
        <div class="form">
          <sn-form [form]="form" [fields]="formFieldsGeneral" [model]="formModel"></sn-form>
        </div>
        <div mat-dialog-actions>
          <button
            class="cancelSubmitButton"
            mat-button
            type="button"
            color="danger"
            mat-dialog-close
          >
            cancel
          </button>
          <button
            class="cancelSubmitButton"
            mat-button
            color="success"
            type="submit"
            (click)="submitGeneral()"
          >
            submit
          </button>
        </div>
      </mat-tab>
      <mat-tab label="Stream">
        <div class="formContainer">
          <div class="form">
            <sn-form [form]="form" [fields]="formFieldsStream" [model]="formModel"></sn-form>
          </div>
        </div>
        <div mat-dialog-actions>
          <button class="cancelSubmitButton" mat-button color="danger" mat-dialog-close>
            cancel
          </button>
          <button
            class="cancelSubmitButton"
            style="margin-bottom: 16px"
            mat-button
            color="success"
            type="submit"
            (click)="submitStream()"
          >
            submit
          </button>
        </div>
      </mat-tab>
      <mat-tab label="Detections">
        <div class="detectionContainer">
        <div class="rules" *ngFor="let aiDetection of detections; let i = index">
          <div class="listItem">
            <mat-list-item>
              <div class="listedItemStyling">{{ aiDetection.name }}</div>
              <hr />
            </mat-list-item>
            <div class="listButtons">
              <button mat-button (click)="editAiDetection(aiDetection)">
                <sn-icon fontSet="fal" fontIcon="fa-pen"></sn-icon>
              </button>
              <button mat-button (click)="removeAiDetection(i)">
                <sn-icon fontSet="fal" fontIcon="fa-trash-alt"></sn-icon>
              </button>
            </div>
          </div>
        </div>

        <button mat-flat-button (click)="createNewDetectionRule()">Add New Rule</button>
        </div>  
        <div mat-dialog-actions id="submitCanceBtn">
          <button mat-button color="danger" mat-dialog-close>cancel</button>
          <button mat-button color="success" (click)="submitGeneral()" type="submit">submit</button>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
